import { createAction, props } from '@ngrx/store';
import { CatalogTable } from '@core/models/catalog.model';
import { SortDirection } from '@rds/angular-components';
import { CatalogPermissions, EntryStatus, Pagination } from '@app/core/models';
import { CatalogTableFilters } from '@app/shared/filters/models/catalog-table';

export const initTable = createAction(
  '[ALL CONTENT] Initialize Channels'
);

export const clearAll = createAction(
  '[ALL CONTENT] Clear all'
);

export const getTableRequest = createAction(
  '[ALL CONTENT] Get channels Request',
  props<{
    pageIndex: number,
    pageSize: number,
    sort: {
      active: string;
      direction: SortDirection
    },
    filters: {[key: string]: any},
  }>()
);

export const getTableSuccess = createAction(
  '[ALL CONTENT] Get channels Success',
  props<{ data: Array<Partial<CatalogTable>>, pagination: Pagination }>()
);

export const getTableFailure = createAction(
  '[ALL CONTENT] Get channels Failure',
  props<{ error: any }>()
);

export const openDeleteEntryConfirmDialog = createAction(
  '[ALL CONTENT] Open confirm delete dialog',
  props<{id: number, name: string, status: EntryStatus}>()
);

export const openProlongEntryConfirmDialog = createAction(
  '[ALL CONTENT] Open confirm prolong entry dialog',
  props<{id: number, name: string}>()
);

export const prolongRequest = createAction(
  '[ALL CONTENT - FORM] Prolong catalog entry request',
  props<{id: number}>()
);

export const prolongSuccess = createAction(
  '[ALL CONTENT - FORM] Prolong catalog entry success'
);

export const prolongFailure = createAction(
  '[ALL CONTENT - FORM] Prolong catalog entry failure',
  props<{error: string}>()
);

export const deleteRequest = createAction(
  '[ALL CONTENT - FORM] Delete catalog entry request',
  props<{id: number, status: EntryStatus}>()
);

export const deleteSuccess = createAction(
  '[ALL CONTENT - FORM] Delete catalog entry success',
  props<{status: EntryStatus}>()
);

export const deleteFailure = createAction(
  '[ALL CONTENT - FORM] Delete catalog entry failure',
  props<{error: string}>()
);

export const changeTableFilters = createAction(
  '[ALL CONTENT] Change channels filters',
  props<{ filters: CatalogTableFilters }>()
);

export const changeTableSort = createAction(
  '[ALL CONTENT] Change channels sort',
  props<{ active: string, direction: SortDirection }>()
);

export const changeTablePagination = createAction(
  '[ALL CONTENT] Change channels pagination',
  props<{ pageIndex: number, pageSize: number }>()
);

export const getCatalogPermissionsRequest = createAction(
  '[ALL CONTENT] Check permissions request',
  props<{ catalogId: number, permissionsToCheck: CatalogPermissions}>()
);

export const getCatalogPermissionsSuccess = createAction(
  '[ALL CONTENT] Check permissions success',
  props<{ permissions: CatalogPermissions}>()
);

export const getCatalogPermissionsFailure = createAction(
  '[ALL CONTENT] Check permissions failure',
  props<{ error: any }>()
);

export const clearCatalogPermissions = createAction(
  '[ALL CONTENT] Clear permissions failure'
);


export const duplicateCatalogRequest = createAction(
  '[ALL CONTENT] Duplicate catalog request',
  props<{ catalogId: number}>()
);

export const duplicateCatalogSuccess = createAction(
  '[ALL CONTENT] Duplicate catalog success',
);

export const duplicateCatalogFailure = createAction(
  '[ALL CONTENT] Duplicate catalog failure',
  props<{ error: any }>()
);
